import React from 'react'
import { CheckCircleIcon, XCircleIcon } from '@primer/octicons-react'
import { dasherize } from '@/utilities'

const ElegidoBox = ({
  nombre,
  elegido,
  reservaescanoreservado,
  paridad,
  sexo,
}) => {
  const firstname = nombre.split(' ')[0]
  return (
    <div>
      {elegido === 'Electo' ? (
        <p className="block p-4 mb-4 text-base leading-none text-center align-baseline bg-lightgreen rounded-default ">
          <span>
            <span className="inline-block rounded-full">
              <CheckCircleIcon className="text-green " size={16} />
            </span>
            <span>
              {' '}
              {firstname}{' '}
              <strong>
                fue {sexo === 'Mujer' ? <>electa</> : <>electo</>} como
                constituyente
                {paridad === 'Sí' ? ' por corrección de paridad' : ''}.
              </strong>{' '}
              <br />
              {/* ¿Quieres conocer sus ideas?
              <br />
              <span className="inline-block px-6 py-2 mt-4 text-white transition-all duration-500 ease-in-out rounded-full bg-azul border-azul hover:bg-rojo">
                Ir al <strong>Match Constituyente</strong>
              </span> */}
            </span>
          </span>
        </p>
      ) : (
        <p className="block p-4 mb-4 text-base leading-none text-center align-baseline bg-gray-300 rounded-default ">
          <span>
            <XCircleIcon size={16} className="text-rojo " />
            <span>
              {' '}
              {firstname}{' '}
              <strong>
                no fue {sexo === 'Mujer' ? <>electa</> : <>electo</>} como
                constituyente
              </strong>
            </span>
          </span>
        </p>
      )}
    </div>
  )
}

export default ElegidoBox
